import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const Frame = ({ src, alt, className = "", label, parallax = true, testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], parallax ? ["-8%", "8%"] : ["0%", "0%"]);
  return (
    <div ref={ref} data-testid={testId} className={`group relative overflow-hidden clip-frame bg-[#14171f] ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        loading="lazy"
        style={{ y, scale: 1.18 }}
        className="absolute inset-0 w-full h-full object-cover grayscale-[35%] group-hover:grayscale-0 transition-[filter] duration-700"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0c0e12]/70 via-transparent to-transparent pointer-events-none" />
      {label && (
        <span className="absolute left-4 bottom-4 font-mono text-xs uppercase tracking-[0.2em] text-[#f4f5f7] bg-[#0c0e12]/70 backdrop-blur px-3 py-1.5">
          {label}
        </span>
      )}
    </div>
  );
};
